import React, { useEffect, useRef, useState } from "react";

// Navigatie in de huisstijl van build 2.4: op laptop een blauwe zijbalk (in te klappen
// tot een smalle icoonbalk), op telefoon een blauwe balk bovenaan met een uitklapmenu.
// Gebruikt door de club-app en de beheerpagina.
//
// items: [{ key, label, icon, active, onClick, badge }] of { heading: "BEHEER" }
// account (optioneel): { name, sub, viewOnly, setViewOnly (null = geen schakelaar),
//                        actions: [{ key, label, icon, onClick, danger }] }

export var NAV_BREAKPOINT = 900;

export function useWide() {
  var [wide, setWide] = useState(window.innerWidth >= NAV_BREAKPOINT);
  useEffect(function () {
    var h = function () { setWide(window.innerWidth >= NAV_BREAKPOINT); };
    window.addEventListener("resize", h);
    return function () { window.removeEventListener("resize", h); };
  }, []);
  return wide;
}

// Ingeklapt of niet, per browser onthouden.
var KEY = "sp-nav-collapsed";
export function useCollapsed() {
  var [c, setC] = useState(function () {
    try { return window.localStorage.getItem(KEY) === "1"; } catch (e) { return false; }
  });
  function toggle() {
    setC(function (v) {
      try { window.localStorage.setItem(KEY, v ? "0" : "1"); } catch (e) { /* geen opslag beschikbaar */ }
      return !v;
    });
  }
  return [c, toggle];
}

export var ICONS = {
  home: ["M3 11l9-7 9 7v9a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1z"],
  planning: ["M12 21a8 8 0 1 0 0-16 8 8 0 0 0 0 16z", "M12 9v4l3 2", "M5 3L2 6", "M19 3l3 3"],
  accounts: ["M9 11.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z", "M2.5 20c.8-3.5 3.4-5.5 6.5-5.5s5.7 2 6.5 5.5", "M16 4.5a3.5 3.5 0 0 1 0 7", "M18 14.8c1.9.7 3.1 2.5 3.5 5.2"],
  beheer: ["M3 3h7v7H3z", "M14 3h7v7h-7z", "M3 14h7v7H3z", "M14 14h7v7h-7z"],
  aanmeldingen: ["M4 4h16v12H8l-4 4z"],
  clubs: ["M3 21V9l9-6 9 6v12", "M9 21v-7h6v7"],
  licenties: ["M3 5h18v14H3z", "M3 10h18", "M7 15h4"],
  terug: ["M15 6l-6 6 6 6"],
  eye: ["M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z", "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"],
  key: ["M8 19a4 4 0 1 0 0-8 4 4 0 0 0 0 8z", "M11 12l9-9", "M17 6l3 3"],
  info: ["M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z", "M12 11v6", "M12 7.5v.5"],
  logout: ["M15 4h4v16h-4", "M10 8l-4 4 4 4", "M6 12h10"],
  menu: ["M4 7h16", "M4 12h16", "M4 17h16"],
  close: ["M6 6l12 12", "M18 6L6 18"],
  collapse: ["M11 17l-5-5 5-5", "M18 17l-5-5 5-5"],
  expand: ["M13 17l5-5-5-5", "M6 17l5-5-5-5"],
  up: ["M6 15l6-6 6 6"],
  week: ["M3 5h18v15H3z", "M3 10h18", "M8 3v4", "M16 3v4"],
  library: ["M4 4h4v16H4z", "M10 4h4v16h-4z", "M16.5 5l3.5 1-3 14-3.5-1z"],
};

export function Icon({ name, d, size }) {
  var paths = d || ICONS[name] || [];
  return (
    <svg width={size || 18} height={size || 18} viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flex: "none" }}>
      {paths.map(function (p, i) { return <path key={i} d={p} />; })}
    </svg>
  );
}

function Logo({ size }) {
  var s = size || 26;
  return (
    <svg width={s} height={s} viewBox="0 0 30 30" aria-hidden="true" style={{ flex: "none" }}>
      <circle cx="15" cy="15" r="13" fill="#F5F3EE" />
      <path d="M5 9c6 3 6 9 0 12M25 9c-6 3-6 9 0 12" stroke="#1A2744" strokeWidth="2" fill="none" strokeLinecap="round" />
    </svg>
  );
}

function initials(name) {
  var parts = String(name || "?").trim().split(/\s+/);
  return (parts[0].charAt(0) + (parts.length > 1 ? parts[parts.length - 1].charAt(0) : "")).toUpperCase();
}

var CSS = `
.an-item{display:flex;align-items:center;gap:10px;min-height:42px;padding:0 12px;border-radius:10px;color:#C9D2E3;background:none;border:none;font-size:15px;font-weight:600;cursor:pointer;text-align:left;width:100%;white-space:nowrap;font-family:inherit;box-sizing:border-box;position:relative}
.an-item:hover{background:#26355A;color:#fff}
.an-item.on{background:#fff;color:#1A2744}
.an-item.danger{color:#F2B8B3}
.an-rail > .an-item{justify-content:center;padding:0;width:44px;margin:0 auto}
.an-head{font-size:11px;font-weight:700;letter-spacing:1px;color:#7F91B5;padding:14px 12px 6px}
.an-badge{margin-left:auto;background:#E8C12E;color:#2A2205;border-radius:999px;font-size:12px;font-weight:800;padding:1px 8px}
.an-rail > .an-item .an-badge{position:absolute;top:2px;right:0;margin:0;font-size:10px;padding:0 5px}
.an-iconbtn{width:36px;height:36px;border-radius:9px;border:none;background:#26355A;color:#C9D2E3;display:flex;align-items:center;justify-content:center;cursor:pointer;flex:none}
.an-iconbtn:hover{color:#fff;background:#2E3E63}
.an-switch{width:40px;height:24px;border-radius:12px;border:none;position:relative;padding:0;cursor:pointer;flex:none}
.an-switch span{position:absolute;top:3px;width:18px;height:18px;border-radius:50%;transition:left .15s}
`;

function Switch({ on, onClick, label }) {
  return (
    <button type="button" role="switch" aria-checked={!!on} aria-label={label} className="an-switch" onClick={onClick} style={{ background: on ? "#E8C12E" : "#34446A" }}>
      <span style={{ left: on ? 19 : 3, background: on ? "#1A2744" : "#C9D2E3" }} />
    </button>
  );
}

function NavItems({ items, rail, onPicked }) {
  return items.map(function (it, i) {
    if (it.heading) return rail ? <div key={"h" + i} style={{ height: 1, background: "#2E3E63", margin: "10px 8px" }} /> : <div key={"h" + i} className="an-head">{it.heading}</div>;
    return (
      <button key={it.key} type="button" className={"an-item" + (it.active ? " on" : "") + (it.danger ? " danger" : "")} aria-current={it.active ? "page" : undefined}
        title={rail ? it.label : undefined} aria-label={rail ? it.label : undefined}
        onClick={function () { if (onPicked) onPicked(); it.onClick(); }}>
        <Icon name={it.icon} />{!rail && it.label}
        {it.badge ? <span className="an-badge">{it.badge}</span> : null}
      </button>
    );
  });
}

// Accountknop onderaan de zijbalk, met een menu dat naar boven openklapt.
function AccountButton({ account, rail }) {
  var [open, setOpen] = useState(false);
  var ref = useRef(null);
  useEffect(function () {
    if (!open) return;
    function onDoc(e) { if (ref.current && !ref.current.contains(e.target)) setOpen(false); }
    document.addEventListener("mousedown", onDoc);
    document.addEventListener("touchstart", onDoc);
    return function () { document.removeEventListener("mousedown", onDoc); document.removeEventListener("touchstart", onDoc); };
  }, [open]);
  return (
    <div ref={ref} style={{ position: "relative", marginTop: 6 }}>
      {open && (
        <div role="menu" style={{ position: "absolute", bottom: "100%", left: 0, marginBottom: 8, width: 240, background: "#1A2744", border: "1px solid #2E3E63", borderRadius: 14, padding: 8, boxShadow: "0 18px 40px rgba(0,0,0,.3)", zIndex: 80 }}>
          <div style={{ padding: "8px 12px 10px", borderBottom: "1px solid #2E3E63", marginBottom: 6 }}>
            <div style={{ color: "#fff", fontWeight: 700, fontSize: 14, overflow: "hidden", textOverflow: "ellipsis" }}>{account.name}</div>
            <div style={{ color: "#9FB0CF", fontSize: 12, overflow: "hidden", textOverflow: "ellipsis" }}>{account.sub}</div>
          </div>
          {account.actions.map(function (a) {
            return <button key={a.key} type="button" role="menuitem" className={"an-item" + (a.danger ? " danger" : "")} onClick={function () { setOpen(false); a.onClick(); }}><Icon name={a.icon} />{a.label}</button>;
          })}
        </div>
      )}
      <button type="button" aria-expanded={open} aria-haspopup="menu" onClick={function () { setOpen(!open); }} title={rail ? account.name : undefined}
        style={{ display: "flex", alignItems: "center", gap: 10, width: rail ? 44 : "100%", margin: rail ? "0 auto" : 0, padding: rail ? 4 : "8px 10px", borderRadius: 12, border: "1px solid #2E3E63", background: "#20305A", color: "#fff", textAlign: "left", fontFamily: "inherit", cursor: "pointer", boxSizing: "border-box", justifyContent: rail ? "center" : "flex-start" }}>
        <span style={{ width: 34, height: 34, borderRadius: "50%", background: "#F5F3EE", color: "#1A2744", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontSize: 13, flex: "none" }}>{initials(account.name)}</span>
        {!rail && <span style={{ flex: 1, minWidth: 0 }}>
          <span style={{ display: "block", fontWeight: 700, fontSize: 14, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{account.name}</span>
          <span style={{ display: "block", fontSize: 12, color: "#9FB0CF", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{account.role}</span>
        </span>}
        {!rail && <span style={{ color: "#9FB0CF", display: "flex" }}><Icon name="up" size={16} /></span>}
      </button>
    </div>
  );
}

export function SideNav({ subtitle, onBrand, items, bottomItems, account, collapsed, onToggle }) {
  var rail = !!collapsed;
  return (
    <nav aria-label="Hoofdmenu" className={rail ? "an-rail" : ""}
      style={{ width: rail ? 68 : 248, flex: "none", background: "#1A2744", padding: rail ? "16px 12px" : "18px 14px", boxSizing: "border-box", display: "flex", flexDirection: "column", gap: 4, position: "sticky", top: 0, height: "100dvh", fontFamily: "'Archivo',system-ui,sans-serif", zIndex: 60, transition: "width .15s" }}>
      <style>{CSS}</style>
      <div style={{ display: "flex", alignItems: "center", gap: 10, padding: rail ? "0 0 12px" : "2px 2px 16px 10px", flexDirection: rail ? "column" : "row" }}>
        <button type="button" onClick={onBrand} title="Naar het begin" style={{ display: "flex", alignItems: "center", gap: 10, background: "none", border: "none", padding: 0, cursor: "pointer", minWidth: 0, flex: rail ? "none" : 1, textAlign: "left", fontFamily: "inherit" }}>
          <Logo />
          {!rail && <span style={{ minWidth: 0 }}>
            <span style={{ display: "block", color: "#fff", fontWeight: 800, fontSize: 16 }}>Seizoensplan</span>
            {subtitle && <span style={{ display: "block", color: "#9FB0CF", fontSize: 12, fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{subtitle}</span>}
          </span>}
        </button>
        <button type="button" className="an-iconbtn" onClick={onToggle} aria-label={rail ? "Zijbalk uitklappen" : "Zijbalk inklappen"} title={rail ? "Zijbalk uitklappen" : "Zijbalk inklappen"}>
          <Icon name={rail ? "expand" : "collapse"} size={16} />
        </button>
      </div>
      <NavItems items={items} rail={rail} />
      <div style={{ flex: 1 }} />
      {bottomItems && <NavItems items={bottomItems} rail={rail} />}
      {account && account.setViewOnly && (rail ? (
        <button type="button" className={"an-item" + (account.viewOnly ? " on" : "")} aria-pressed={!!account.viewOnly} title={"Bekijkmodus " + (account.viewOnly ? "uit" : "aan") + "zetten"} aria-label="Bekijkmodus" onClick={function () { account.setViewOnly(!account.viewOnly); }}><Icon name="eye" /></button>
      ) : (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10, minHeight: 42, padding: "0 12px", color: "#C9D2E3", fontSize: 14, fontWeight: 600 }}>
          <span style={{ display: "flex", alignItems: "center", gap: 10 }}><Icon name="eye" />Bekijkmodus</span>
          <Switch on={account.viewOnly} label="Bekijkmodus" onClick={function () { account.setViewOnly(!account.viewOnly); }} />
        </div>
      ))}
      {account && <AccountButton account={account} rail={rail} />}
    </nav>
  );
}

export function MobileBar({ subtitle, onBrand, items, bottomItems, account, right }) {
  var [open, setOpen] = useState(false);
  return (
    <div style={{ position: "sticky", top: 0, zIndex: 70, fontFamily: "'Archivo',system-ui,sans-serif", flex: "none" }}>
      <style>{CSS}</style>
      <header style={{ background: "#1A2744", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10, padding: "8px 12px 8px 16px", minHeight: 60, boxSizing: "border-box" }}>
        <button type="button" onClick={function () { setOpen(false); onBrand(); }} style={{ display: "flex", alignItems: "center", gap: 10, minWidth: 0, background: "none", border: "none", padding: 0, cursor: "pointer", textAlign: "left", fontFamily: "inherit" }}>
          <Logo />
          <span style={{ minWidth: 0 }}>
            <span style={{ display: "block", color: "#fff", fontWeight: 800, fontSize: 16, lineHeight: 1.1 }}>Seizoensplan</span>
            {subtitle && <span style={{ display: "block", color: "#9FB0CF", fontSize: 12, fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{subtitle}</span>}
          </span>
        </button>
        <div style={{ display: "flex", alignItems: "center", gap: 8, flex: "none" }}>
          {right}
          <button type="button" aria-expanded={open} aria-label={open ? "Menu sluiten" : "Menu openen"} onClick={function () { setOpen(!open); }}
            style={{ width: 44, height: 44, borderRadius: 10, border: "none", background: open ? "#fff" : "#26355A", color: open ? "#1A2744" : "#fff", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
            <Icon name={open ? "close" : "menu"} size={20} />
          </button>
        </div>
      </header>
      {open && <>
        <div onClick={function () { setOpen(false); }} style={{ position: "fixed", left: 0, right: 0, top: 60, bottom: 0, background: "rgba(20,24,36,.45)" }} />
        <nav aria-label="Hoofdmenu" style={{ position: "absolute", left: 0, right: 0, top: "100%", background: "#1A2744", padding: "6px 12px 16px", borderRadius: "0 0 18px 18px", boxShadow: "0 18px 40px rgba(0,0,0,.25)", display: "flex", flexDirection: "column", gap: 2, maxHeight: "calc(100dvh - 60px)", overflowY: "auto", boxSizing: "border-box" }}>
          <NavItems items={items} onPicked={function () { setOpen(false); }} />
          {bottomItems && <><div style={{ height: 1, background: "#2E3E63", margin: "10px 4px" }} /><NavItems items={bottomItems} onPicked={function () { setOpen(false); }} /></>}
          {account && <>
            <div style={{ height: 1, background: "#2E3E63", margin: "10px 4px" }} />
            <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "6px 12px 8px" }}>
              <span style={{ width: 36, height: 36, borderRadius: "50%", background: "#F5F3EE", color: "#1A2744", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontSize: 13, flex: "none" }}>{initials(account.name)}</span>
              <span style={{ minWidth: 0 }}>
                <span style={{ display: "block", fontWeight: 700, fontSize: 15, color: "#fff", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{account.name}</span>
                <span style={{ display: "block", fontSize: 12, color: "#9FB0CF", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{account.sub}</span>
              </span>
            </div>
            {account.setViewOnly && (
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10, minHeight: 44, padding: "0 12px", color: "#DCE3F0", fontSize: 15, fontWeight: 600 }}>
                <span style={{ display: "flex", alignItems: "center", gap: 10 }}><Icon name="eye" />Bekijkmodus</span>
                <Switch on={account.viewOnly} label="Bekijkmodus" onClick={function () { account.setViewOnly(!account.viewOnly); }} />
              </div>
            )}
            <NavItems items={account.actions} onPicked={function () { setOpen(false); }} />
          </>}
        </nav>
      </>}
    </div>
  );
}

// Balk onderin op de telefoon (build 2.5): Seizoensoverzicht, Weekoverzicht en
// Bibliotheek. `fixed`: vast onderin beeld (gewone schermen); anders gewoon onderaan
// in de kolom (Weekoverzicht, dat zelf de hele hoogte vult).
// items: [{ key, label, icon, active, onClick }]
export function BottomBar({ items, fixed }) {
  return (
    <nav aria-label="Hoofdnavigatie" style={Object.assign({
      background: "#fff", borderTop: "1px solid #E2DED5", display: "grid",
      gridTemplateColumns: "repeat(" + items.length + ", minmax(0, 1fr))",
      padding: "6px 6px calc(8px + env(safe-area-inset-bottom, 0px))", zIndex: 65,
      fontFamily: "'Archivo',system-ui,sans-serif", boxSizing: "border-box", flex: "none",
    }, fixed ? { position: "fixed", left: 0, right: 0, bottom: 0 } : {})}>
      {items.map(function (it) {
        return (
          <button key={it.key} type="button" onClick={it.onClick} aria-current={it.active ? "page" : undefined}
            style={{ minHeight: 52, border: 0, background: "none", color: it.active ? "#1A2744" : "#6B675F", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 3, fontSize: 12, fontWeight: it.active ? 800 : 600, cursor: "pointer", fontFamily: "inherit", padding: "0 2px", minWidth: 0 }}>
            <span style={{ background: it.active ? "#E7E3DA" : "transparent", borderRadius: 999, padding: "3px 16px", display: "flex" }}><Icon name={it.icon} size={22} /></span>
            <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "100%" }}>{it.label}</span>
          </button>
        );
      })}
    </nav>
  );
}

// Ruimte onderaan de inhoud zodat de vaste balk niets afdekt.
export var BOTTOM_BAR_SPACE = 78;
